import urls from '../api_urls/newVideoManagement'
import { _post, _upload } from '@/axios/request'
// 获取列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}
export function changeStatus (params) {
  return _post(urls.CHANGE_STATUS, params)
}
export function del (params) {
  return _post(urls.DEL, params)
}
export function find (params) {
  return _post(urls.FIND, params)
}
export function uploadFile (params) {
  return _upload(urls.UPLOAD_FILE, params)
}
export function saveOrUpdate (params) {
  return _post(urls.SAVE_OR_UPDATE, params)
}
export function updateVideo (params) {
  return _post(urls.UPDATE_VIDEO, params)
}
export function createVideoUrl (params) {
  return _post(urls.CREATE_URL, params)
}
export function refreshVideoUrl (params) {
  return _post(urls.REFRESH_URL, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/newVideoManagement.js